import { interactionEvent } from 'lib/analytics/gtmEventShapes';
import { fetchSearchResultsSuccess } from 'store/search/searchActions';
import { getPageFromState } from './helpers';
import { getQueryParams } from 'store/router/routerSelectors';

const mapQueryParamToGTMVariables = ({ adults, children, infants, checkIn, checkOut, location }) => ({
  numAdults: adults,
  numChildren: children,
  numInfants: infants,
  checkIn,
  checkOut,
  location,
});

const emitFetchSearchResultsSuccessEvent = (action, prevState) => {
  const { results } = action.payload;
  const page = getPageFromState(prevState);
  const queryParams = getQueryParams(prevState);

  const mappedGTMVariables = mapQueryParamToGTMVariables(queryParams);
  const eventType = results.length > 0 ? 'Successful Search' : 'Unsuccessful Search';

  return interactionEvent({ type: eventType, value: queryParams.location, page: page.name, customAttributes: mappedGTMVariables });
};

export default { [fetchSearchResultsSuccess]: emitFetchSearchResultsSuccessEvent };
